<template>
  <div class="control-sections" style="overflow: hidden">
    <div
      class="col-lg-12 control-section inplace-editor-control-section form-layout"
      id="inplace-editor-control"
    >
      <div
        class="content-wrapper"
        style="
          margin-bottom: 25px;
          font-family: 'Noto Sans JP';
          font-size: 14px;
          line-height: 21px;
        "
      >
        <div id="confirmation">
          <form id="formId" class="form-horizontal">
            <div class="form-group">
              <ejs-inplaceeditor
                :locale="locale"
                class="inplaceEditor"
                ref="rteObj"
                id="inplace_comment_editor"
                data-underline="false"
                mode="Inline"
                editableOn="EditIconClick"
                submitOnEnter="false"
                type="RTE"
                :emptyText="EnterOtherInfo"
                name="rte"
                :value="otherInformation"
                :actionSuccess="actionSuccess"
                :popupSettings="popupSettings"
                :model="commentModel"
                width="100%"
                :disabled="!isEdit || !isPhotoUploading"
                actionOnBlur="ignore"
                :endEdit="endEdit"
                :beginEdit="beforeEdit"
                :change="change"
                :cancelClick="cancelClick"
              >
              </ejs-inplaceeditor>
              <div class="error-element" v-if="isImagePresent">
                <span style="color: var(--v-error-base) !important">{{
                  $t("imageNotAllowed")
                }}</span>
              </div>
            </div>
          </form>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import Vue from "vue";
import { InPlaceEditorPlugin, Rte } from "@syncfusion/ej2-vue-inplace-editor";
import { FormValidator } from "@syncfusion/ej2-inputs";
import { L10n } from "@syncfusion/ej2-base";
import * as localeText from "@/Langs/locale.json";
L10n.load(localeText.default);
Vue.use(InPlaceEditorPlugin);
let multiData = [
  "Android",
  "JavaScript",
  "jQuery",
  "TypeScript",
  "Angular",
  "React",
  "Vue",
  "Ionic",
];
export default {
  name: "InlineEditableRichText",
  data() {
    return {
      isImagePresent: false,
      textValidationRules: {
        rte: {
          required: [true, this.$t("agenda.msgIsMandatory")],
          regex: [this.checkString, this.$t("agenda.msgIsMandatory")],
        },
      },
      commentValidationRules: {
        rte: { required: [true, "Enter valid comments"] },
      },
      popupSettings: {
        model: { width: 300 },
      },
      commentModel: {
        toolbarSettings: {
          enableFloating: false,
          items: [
            "Bold",
            "Italic",
            "Underline",
            "FontColor",
            "BackgroundColor",
            "LowerCase",
            "UpperCase",
            "|",
            "OrderedList",
            "UnorderedList",
          ],
        },
        quickToolbarSettings: {
          table: [
            "TableHeader",
            "TableRows",
            "TableColumns",
            "TableCell",
            "-",
            "BackgroundColor",
            "TableRemove",
            "TableCellVerticalAlign",
            "Styles",
          ],
        },
      },
      //EnterOtherInfo: this.$t("people.EnterOtherInfo"),
    };
  },
  props: {
    // otherInformation: String,
    value: {
      type: String,
      default: "",
    },
    isEdit: Boolean,
    isPhotoUploading: {
      type: Boolean,
      default: true,
    },
  },
  watch: {
    isImagePresent(val) {
      let descriptionSaveBtn = document.getElementsByClassName("e-btn-save");
      if (descriptionSaveBtn.length) {
        descriptionSaveBtn[0].disabled = val;
      }
      this.$emit("descriptionWithImg", val);
    },
  },
  computed: {
    locale() {
      return this.$i18n.locale;
    },
    otherInformation: {
      get() {
        return this.value;
      },
      set(value) {
        this.$emit("input", value || "");
      },
    },
    EnterOtherInfo() {
      return this.$t("people.EnterOtherInfo");
    },
  },
  mounted: function () {
    this.rteObj = this.$refs.rteObj.ej2Instances;
    this.rteObj.popupSettings.model.width =
      document.querySelector("#inplace-editor-control.form-layout")
        .offsetWidth ?? 0;

    this.rteObj.editIcon.title = this.$t("people.tipUpdateDescription");

    this.rteObj.disabled = !this.isEdit;
  },
  methods: {
    beforeEdit() {
      this.isImagePresent = this.otherInformation.includes("<img src=");
    },
    change(args) {
      if (args.value) {
        this.isImagePresent = args.value.includes("<img src=");
      } else {
        this.isImagePresent = false;
      }
    },
    cancelClick(args) {
      this.isImagePresent = this.otherInformation.includes("<img src=");
    },
    endEdit(args) {
      this.rteObj.editIcon.title = this.$t("people.tipUpdateDescription");
    },
    checkString(args) {
      const str = args.value
        ? args.value.replace(/(<([^>]+)>)/gi, "").replace(/&nbsp;/gi, "")
        : "";
      return str && str.trim().length > 0 ? true : false;
    },
    actionSuccess: function (args) {
      var val = args.value;
      args.value = val;
      this.otherInformation = val;
    },
  },
  provide: {
    inplaceeditor: [Rte],
  },
};
</script>
<style scoped>
.e-inplaceeditor {
  width: 100% !important;
  z-index: 1 !important;
}
.inplaceEditor /deep/ .e-editable-value {
  font-family: "Noto Sans JP";
  font-size: 14px;
  line-height: 21px;
}
.inplaceEditor /deep/ .e-editable-action-buttons {
  z-index: 98 !important;
}
</style>